import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const fileUrl = (url, download = false) => (url ? `${BASE}${url}${download ? "&download=1" : ""}` : "");

export const useEntitlement = () => {
  const { user } = useAuth();
  const [ent, setEnt] = useState(null);
  const refresh = useCallback(async () => {
    if (!user) {
      setEnt(null);
      return;
    }
    try {
      const { data } = await api.get("/me/entitlement");
      setEnt(data ?? null);
    } catch {
      setEnt(null);
    }
  }, [user]);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return { ent, refresh };
};

export const creditLabel = (ent) => {
  if (!ent) return "—";
  if (ent.admin) return "Illimitati (Admin)";
  if (ent.abbonato && ent.crediti_rimasti == null) return `Illimitati (Piano ${ent.nome_piano} 19€)`;
  if (ent.abbonato) return `${ent.crediti_rimasti} video questo mese (Piano ${ent.nome_piano} 9€)`;
  const n = ent.crediti_rimasti ?? (ent.prova_disponibile ? 1 : 0);
  if (n <= 0) return "0 (video gratuiti usati)";
  return n === 1 ? "1 video gratuito" : `${n} video gratuiti`;
};

export const creditHint = (user, ent) => {
  if (!user) return "Accedi con Google: il primo video è gratis.";
  if (!ent) return "";
  if (ent.abbonato && ent.crediti_rimasti == null) return "Video illimitati attivi.";
  if (ent.abbonato) return ent.crediti_rimasti > 0 ? `Ti restano ${ent.crediti_rimasti} video questo mese.` : "Hai usato i video del mese: passa a Pro per i video illimitati.";
  if (ent.prova_disponibile) return ent.crediti_rimasti > 1 ? `Hai ${ent.crediti_rimasti} video gratuiti.` : "Hai 1 video gratuito.";
  return "Video gratuiti usati: scegli Starter o Pro per continuare.";
};

export const downloadVideo = (video) => {
  const a = document.createElement("a");
  a.href = fileUrl(video?.video_url, true);
  a.download = "";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const shareTikTok = async (video) => {
  try {
    const res = await api.get(video.video_url.replace(/^\/api/, ""), { responseType: "blob" });
    const file = new File([res.data], "mimis-video.mp4", { type: "video/mp4" });
    if (navigator.canShare?.({ files: [file] })) {
      await navigator.share({ files: [file], title: video.titolo || "Il mio video MIMIS" });
      return;
    }
  } catch (e) {
    if (e?.name === "AbortError") return;
  }
  downloadVideo(video);
  toast.success("Video scaricato! Ora caricalo su TikTok dalla pagina che si è aperta.");
  window.open("https://www.tiktok.com/upload", "_blank", "noopener");
};
